/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type LocationDtoType = typeof LocationDtoType[keyof typeof LocationDtoType];


export const LocationDtoType = {
  region: 'region',
  district: 'district',
  municipality: 'municipality',
} as const;
